var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-form-model",
        {
          ref: "registerForm",
          staticClass: "ec-register-form switch-form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            hideRequiredMark: "",
            colon: false,
            labelAlign: "left",
          },
        },
        [
          _c(
            "a-form-model-item",
            {
              staticClass: "input-addon-before-form-item",
              attrs: {
                prop: "phone",
                label: _vm.$t("common_form_phone"),
                htmlFor: "phone",
              },
            },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "forlogin",
                    rawName: "v-forlogin",
                    value: "phone",
                    expression: "'phone'",
                  },
                ],
                attrs: { autoComplete: "off", maxLength: 11 },
                on: {
                  keyup: function ($event) {
                    _vm.form.phone = _vm.form.phone.replace(/[^\d]/g, "")
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "addonBefore",
                    fn: function () {
                      return [
                        _c("PhoneCode", {
                          attrs: { getPopupContainer: () => _vm.$el },
                          on: { changeCode: _vm.changeCode },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.form.phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "phone", $$v)
                  },
                  expression: "form.phone",
                },
              }),
            ],
            1
          ),
          _vm.showImgCode
            ? _c(
                "a-form-model-item",
                {
                  attrs: {
                    prop: "imgCode",
                    label: _vm.$t("common_form_identifying_code"),
                    htmlFor: "imgCode",
                  },
                },
                [
                  _c(
                    "a-input",
                    {
                      directives: [
                        {
                          name: "forlogin",
                          rawName: "v-forlogin",
                          value: "imgCode",
                          expression: "'imgCode'",
                        },
                      ],
                      attrs: { autoComplete: "off", maxLength: 4 },
                      model: {
                        value: _vm.form.imgCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "imgCode", $$v)
                        },
                        expression: "form.imgCode",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            width: "56px",
                            height: "33px",
                            background: "rgb(253, 253, 253)",
                          },
                          attrs: { slot: "suffix" },
                          slot: "suffix",
                        },
                        [
                          _vm.imgCodeLoading
                            ? _c("a-spin", {
                                staticStyle: {
                                  "margin-left": "25px",
                                  "margin-top": "9px",
                                },
                                attrs: { size: "small" },
                              })
                            : _c("img", {
                                staticStyle: {
                                  cursor: "pointer",
                                  width: "100%",
                                  height: "100%",
                                },
                                attrs: { src: _vm.imgCodeData },
                                on: { click: _vm.getImgCode },
                              }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "a-form-model-item",
            {
              attrs: {
                prop: "shortMessageCode",
                label: _vm.$t("common_form_sms_code"),
                htmlFor: "shortMessageCode",
              },
            },
            [
              _c(
                "a-input",
                {
                  directives: [
                    {
                      name: "forlogin",
                      rawName: "v-forlogin",
                      value: "shortMessageCode",
                      expression: "'shortMessageCode'",
                    },
                  ],
                  attrs: { maxLength: 6, autoComplete: "off" },
                  model: {
                    value: _vm.form.shortMessageCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "shortMessageCode", $$v)
                    },
                    expression: "form.shortMessageCode",
                  },
                },
                [
                  _c(
                    "a-spin",
                    {
                      attrs: {
                        slot: "suffix",
                        spinning: _vm.isCodeLoading && !_vm.timing,
                      },
                      slot: "suffix",
                    },
                    [
                      _c(
                        "a-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.timing,
                              expression: "!timing",
                            },
                          ],
                          attrs: { id: "captcha-button", type: "link" },
                        },
                        [_vm._v(_vm._s(_vm.$t("common_btn_send_ver")))]
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.timing,
                              expression: "timing",
                            },
                          ],
                        },
                        [_vm._v(_vm._s(_vm.timing) + " s")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            {
              attrs: {
                prop: "companyName",
                label: _vm.$t("common_form_company_name"),
                htmlFor: "companyName",
              },
            },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "forlogin",
                    rawName: "v-forlogin",
                    value: "companyName",
                    expression: "'companyName'",
                  },
                ],
                attrs: { maxLength: 50, autoComplete: "off" },
                model: {
                  value: _vm.form.companyName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "companyName", $$v)
                  },
                  expression: "form.companyName",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            {
              attrs: {
                prop: "inviteCode",
                label: _vm.$t("common_form_Invitation"),
                htmlFor: "inviteCode",
              },
            },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "forlogin",
                    rawName: "v-forlogin",
                    value: "inviteCode",
                    expression: "'inviteCode'",
                  },
                ],
                attrs: { autoComplete: "off" },
                model: {
                  value: _vm.form.inviteCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "inviteCode", $$v)
                  },
                  expression: "form.inviteCode",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ec-register-agreement" },
        [
          _c(
            "a-checkbox",
            {
              staticClass: "login-form__checkbox",
              model: {
                value: _vm.agreement,
                callback: function ($$v) {
                  _vm.agreement = $$v
                },
                expression: "agreement",
              },
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("common_login_I_read_agress"))),
              ]),
              _c(
                "a-button",
                {
                  attrs: { type: "link" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("agreement", "agreementVisible")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common_login_ServiceAgreement")))]
              ),
              _c("span", [_vm._v(_vm._s(_vm.$t("common_conj_and")))]),
              _c(
                "a-button",
                {
                  attrs: { type: "link" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("agreement", "policyVisible")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common_login_PrivacyPolicy")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a",
        {
          staticClass: "ec-register-submit",
          class: { "ec-register-submit__loading": _vm.submitLoading },
          on: {
            keyup: function ($event) {
              if (!$event.type.indexOf("key") && $event.keyCode !== 13)
                return null
              return _vm.onSubmit.apply(null, arguments)
            },
          },
        },
        [
          _vm.submitLoading
            ? _c(
                "a-spin",
                [
                  _c("a-icon", {
                    staticStyle: { "font-size": "24px", color: "#fff" },
                    attrs: { slot: "indicator", type: "loading", spin: "" },
                    slot: "indicator",
                  }),
                ],
                1
              )
            : _c(
                "div",
                {
                  staticStyle: { flex: "1", "text-align": "center" },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v(_vm._s(_vm.$t("common_login_register")))]
              ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "center",
            "margin-top": "10px",
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                margin: "1px",
                height: "30px",
                "font-size": "14px",
                "font-weight": "400",
                display: "flex",
                "align-items": "center",
              },
            },
            [_vm._v(_vm._s(_vm.$t("common_login_register_tip")))]
          ),
          _c(
            "a-button",
            {
              staticStyle: { padding: "0 4px" },
              attrs: { type: "link" },
              on: {
                click: function ($event) {
                  return _vm.$emit("to", "login")
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common_login_login_btn")) + " ")]
          ),
        ],
        1
      ),
      _c("div", { attrs: { id: "captcha-element" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }